/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/** Utilities */
import { encryptUrlData } from '../../../services/CryptoService';
import { getAuthProps } from '../../../lib/authenticationLibrary';

/** Common Components */
import MolGrid from "../../../components/Grid/MolGrid"

/** Configuration FIles */
import { myInterviewGridConfig } from '../myInterviewGridConfig.data'

/** RTK Query */
import { useGetScheduledCandidateListByUserIdMutation } from '../../../app/services/candidateAPI';

const MyInterviewList = (props) => {

    const molGridRef = useRef();

    const [dataSource, setDataSource] = useState();
    const [totalRowCount, setTotalRowCount] = useState(0);

    const navigate = useNavigate();
    const cookies = getAuthProps();

    const [getScheduledCandidateListByUserId, {
        isLoading: isListLoading,
        isSuccess: isListSuccess,
        data: scheduledListData
    }] = useGetScheduledCandidateListByUserIdMutation();

    const getScheduledCandidateList = (pageObject, searchText) => {
        if (cookies?.user?.userID) {
            const request = {
                pagination: { pageNumber: pageObject.pageNumber, pageSize: pageObject.pageSize },
                filters: { searchText: searchText },
                interviewerUserId: cookies.user.userID
            }
            getScheduledCandidateListByUserId(request);
        }
    }

    const handleEditClick = (data) => {
        navigate(`/MyInterviewDetails/${(encryptUrlData(data.candidateId))}`);
    };

    const handlePageChange = () => {
        getScheduledCandidateList(molGridRef.current.getCurrentPageObject(), props.search);
    }

    useEffect(() => {
        getScheduledCandidateList(molGridRef.current.getCurrentPageObject(), props.search);
    }, [props.search])

    useEffect(() => {
        if (isListSuccess && scheduledListData) {
            if (scheduledListData.dataSource) {
                setDataSource(scheduledListData.dataSource)
            }
            if (scheduledListData.totalCount) {
                setTotalRowCount(scheduledListData.totalCount)
            }
        }
    }, [isListSuccess, scheduledListData]);

    const actionHandler = {
        EDIT: handleEditClick,
    };

    return (
        <MolGrid
            ref={molGridRef}
            configuration={myInterviewGridConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={{
                totalCount: totalRowCount,
                pageSize: 20,
                currentPage: 1,
            }}
            onActionChange={actionHandler}
            isLoading={isListLoading}
            onPageChange={handlePageChange}
        />
    )
}

export default MyInterviewList